import { http, requireResults, results } from './client';

/** Pay-at-hotel / card-guarantee booking with a hotel partner (requires sign-in). */
export const createPartnerBooking = (payload) =>
  http.post('api/v1/hotels/booking', payload).then(requireResults);

/** Every booking for the signed-in user (partner and self-hosted, newest stay first). */
export const listMyBookings = () =>
  http.get('api/v1/hotels/booking/all').then((r) => results(r) || []);

/** Cancels one of the signed-in user's bookings (any provider). */
export const cancelMyBooking = (bookingNumber) =>
  http
    .post('api/v1/hotels/booking/in/cancel', { booking_number: bookingNumber })
    .then(requireResults);

/** Cancels from the link in the confirmation email (no sign-in needed). */
export const cancelWithEmailToken = ({ token, bookingNumber, provider }) =>
  http
    .post('api/v1/hotels/booking/cancel', {
      token,
      booking_number: bookingNumber,
      provider: provider ?? null,
    })
    .then(requireResults);
